module.exports = __webpack_public_path__ + "static/media/21_A.25265adf.png";